export default __webpack_public_path__ + "static/media/icon-node-locked.c8024eb5.svg";